import React, { useState, createContext, useContext } from 'react';
interface ClientContextType {
  clientName: string;
  setClientName: (name: string) => void;
  companyName: string;
  setCompanyName: (name: string) => void;
}
const ClientContext = createContext<ClientContextType>({
  clientName: 'Rakesh Parekh',
  setClientName: () => {},
  companyName: 'Storyboard Studio',
  setCompanyName: () => {}
});
export function ClientProvider({
  children
}: {
  children: ReactNode;
}) {
  const [clientName, setClientName] = useState('Rakesh Parekh');
  const [companyName, setCompanyName] = useState('Storyboard Studio');
  return <ClientContext.Provider value={{
    clientName,
    setClientName,
    companyName,
    setCompanyName
  }} data-id="element-34">
      {children}
    </ClientContext.Provider>;
}
export function useClient() {
  return useContext(ClientContext);
}